<template>
  <div :class="style.assistantMessage">
    <span class="sr-only">
      {{ i18n(translations.emittedFromAssistant) }}
    </span>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { useCssModule } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from '../ShoppingAssistant.translations'

const i18n = useI18n()
const style = useCssModule()
</script>

<style module>
.assistantMessage b {
  @apply text-body-1-bold;
}

.assistantMessage a {
  @apply body-1-link;
}
</style>
